import React, { useState, useEffect } from "react";
import { useAuth } from "../../lib/auth";
import { useContent } from "../../lib/content";
import { Field, TextArea, Msg, Section } from "../../components/admin/FormKit";
import { DEFAULT_CONTACT } from "../../lib/seed";
import { Save, Phone } from "lucide-react";

export default function AdminContact() {
  const { r2 } = useAuth();
  const { contact, saveContact } = useContent();
  const [form, setForm] = useState(contact);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setForm({ ...DEFAULT_CONTACT, ...contact });
  }, [contact]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setMsg("");
    try {
      await saveContact(r2, form);
      setMsg("صفحه تماس ذخیره شد ✓");
    } catch (e) {
      setMsg(e.message || String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-10" data-testid="admin-contact-panel">
      <Section
        title="صفحه تماس"
        icon={Phone}
        desc="شماره واتساپ، ایمیل و آدرس واقعی از تب «تنظیمات سایت» ویرایش می‌شود. اینجا فقط متن‌های صفحه را ویرایش می‌کنید."
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Eyebrow" value={form.eyebrow} onChange={(v) => setForm({ ...form, eyebrow: v })} testid="admin-contact-eyebrow" />
          <Field label="تیتر صفحه" value={form.title} onChange={(v) => setForm({ ...form, title: v })} testid="admin-contact-title" />
          <TextArea full rows={3} label="متن معرفی" value={form.intro} onChange={(v) => setForm({ ...form, intro: v })} testid="admin-contact-intro" />
          <Field label="زیرنویس کارت واتساپ" value={form.whatsapp_subtitle} onChange={(v) => setForm({ ...form, whatsapp_subtitle: v })} />
          <Field label="زیرنویس کارت اینستاگرام" value={form.instagram_subtitle} onChange={(v) => setForm({ ...form, instagram_subtitle: v })} />
          <Field label="زیرنویس کارت فیسبوک" value={form.facebook_subtitle} onChange={(v) => setForm({ ...form, facebook_subtitle: v })} />
          <Field label="زیرنویس کارت ایمیل" value={form.email_subtitle} onChange={(v) => setForm({ ...form, email_subtitle: v })} />
          <Field label="زیرنویس کارت تلفن (ساعت کاری)" value={form.phone_subtitle} onChange={(v) => setForm({ ...form, phone_subtitle: v })} />
          <Field label="زیرنویس کارت آدرس" value={form.address_subtitle} onChange={(v) => setForm({ ...form, address_subtitle: v })} />
        </div>
      </Section>

      <div className="flex items-center justify-between sticky bottom-4 bg-paper/95 backdrop-blur border border-honey-200 rounded-full px-4 py-2 shadow-lg">
        <Msg msg={msg} />
        <button
          type="submit"
          disabled={busy}
          className="inline-flex items-center gap-2 bg-honey-500 hover:bg-honey-600 text-white font-display font-bold px-5 py-2.5 rounded-full disabled:opacity-60"
          data-testid="admin-contact-save"
        >
          <Save className="w-4 h-4" /> {busy ? "در حال ذخیره..." : "ذخیره"}
        </button>
      </div>
    </form>
  );
}
